// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscription .subscription-content {
  background: var(--ons-color-white);
  border-radius: 4px;
  padding: 20px;
  text-align: center;
  width: 100%;
  border: 1px solid var(--ons-color-white);
}
.subscription .subscription-content ion-icon {
  font-size: 50px;
}
.subscription .subscription-content .subscription-title {
  font-family: var(--ons-font-bold);
  font-size: 16px;
  margin-bottom: 5px;
  color: var(--ons-color-primary-black);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.subscription .subscription-content .subscription-title .active {
  font-family: var(--ons-font-medium);
  padding: 5px 7px;
  border-radius: 4px;
  background: var(--ons-color-primary);
  color: var(--ons-color-white);
  font-size: 12px;
  margin-top: 10px;
}
.subscription .subscription-content .subscription-title .active.expired {
  background: var(--ons-color-red);
}
.subscription .subscription-content .subscription-title .active.cancelled {
  background: var(--ons-color-orange);
}
.subscription .subscription-content .subscription-desc {
  font-family: var(--ons-font-medium);
  font-size: 12px;
  margin: 0 5px;
  color: var(--ons-color-grey);
  width: 100%;
}
.subscription .subscription-content .subscription-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 300px;
  margin: 0 auto;
}
.subscription .subscription-content .subscription-buttons .subscription-button {
  background: var(--ons-color-primary-black);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: var(--ons-color-white);
  font-family: var(--ons-font-bold);
  height: 30px;
  min-width: 30px;
  width: 30px;
  transition: 0.5s all;
  cursor: pointer;
}
.subscription .subscription-content .subscription-buttons .subscription-button.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.subscription.active .subscription-content {
  border-color: var(--ons-color-primary);
}

.subscription-price {
  text-align: center;
  font-family: var(--ons-font-bold);
  font-size: 18px;
  margin-top: 10px;
  color: var(--ons-color-grey);
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/subscription-select/subscription-select.component.scss"],"names":[],"mappings":"AACI;EACI,kCAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,wCAAA;AAAR;AAEQ;EACI,eAAA;AAAZ;AAGQ;EACI,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,qCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AADZ;AAGY;EACI,mCAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;AADhB;AAGgB;EACI,gCAAA;AADpB;AAIgB;EACI,mCAAA;AAFpB;AAMQ;EACI,mCAAA;EACA,eAAA;EACA,aAAA;EACA,4BAAA;EACA,WAAA;AAJZ;AAOQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AALZ;AAOY;EACI,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,6BAAA;EACA,iCAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;EACA,eAAA;AALhB;AAOgB;EACI,YAAA;EACA,oBAAA;AALpB;AAWI;EACI,sCAAA;AATR;;AAaA;EACI,kBAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;AAVJ","sourcesContent":[".subscription {\n    .subscription-content {\n        background: var(--ons-color-white);\n        border-radius: 4px;\n        padding: 20px;\n        text-align: center;\n        width: 100%;\n        border: 1px solid var(--ons-color-white);\n\n        ion-icon {\n            font-size: 50px;\n        }\n\n        .subscription-title {\n            font-family: var(--ons-font-bold);\n            font-size: 16px;\n            margin-bottom: 5px;\n            color: var(--ons-color-primary-black);\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            flex-direction: column;\n\n            .active {\n                font-family: var(--ons-font-medium);\n                padding: 5px 7px;\n                border-radius: 4px;\n                background: var(--ons-color-primary);\n                color: var(--ons-color-white);\n                font-size: 12px;\n                margin-top: 10px;\n\n                &.expired {\n                    background: var(--ons-color-red);\n                }\n\n                &.cancelled {\n                    background: var(--ons-color-orange);\n                }\n            }\n        }\n        .subscription-desc {\n            font-family: var(--ons-font-medium);\n            font-size: 12px;\n            margin: 0 5px;\n            color: var(--ons-color-grey);\n            width: 100%;\n        }\n\n        .subscription-buttons {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            max-width: 300px;\n            margin: 0 auto;\n\n            .subscription-button {\n                background: var(--ons-color-primary-black);\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                border-radius: 4px;\n                color: var(--ons-color-white);\n                font-family: var(--ons-font-bold);\n                height: 30px;\n                min-width: 30px;\n                width: 30px;\n                transition: 0.5s all;\n                cursor: pointer;\n\n                &.disabled {\n                    opacity: 0.5;\n                    pointer-events: none;\n                }\n            }\n        }\n    }\n\n    &.active .subscription-content {\n        border-color: var(--ons-color-primary);\n    }\n}\n\n.subscription-price {\n    text-align: center;\n    font-family: var(--ons-font-bold);\n    font-size: 18px;\n    margin-top: 10px;\n    color: var(--ons-color-grey);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
